import styled, { CSSObject } from '@emotion/styled';

export const GridFilterItemContainer = styled.div(
  (): CSSObject => ({
    margin: '1rem',
  })
);
